import { InputAdornment } from "@mui/material";
import lockicon from "../../../../images/lockIcon.png";

export default function configNewTeam(values) {
  console.log(values.leagues, "configNewTeam")
  console.log(values.games, "games")
  console.log(values.currentFormData, "currentFormData")
  console.log(values.formColors, "formColors")
  console.log(values.fieldsDisabled, "fieldsDisabled")
  
  return [
    {
      shape: "div",
      type: "wrapper",
      className: "",
      sx: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gridColumnGap: "100px",
      },
      children: [
        {
          shape: "input",
          type: "text",
          name: "league_id",
          className: "border",
          title: "League Id",
          label: "League Id",
          placeholder: "ID",
          width: "100%",
          isDisabled: true,
          value: values.currentFormData?.league_id || "",
          inputAdornments: {
            end: <InputAdornment position="end"> <img src={lockicon} alt='lockicon'/></InputAdornment>,
          }
        },
         {
          shape: "input",
          type: "select",
          name: "game_id",
          className: "border",
          title: "Game",
          label: "Sports",
          options: values.games || [],
          placeholder: "Select Game",
          width: "100%",
          value: values.currentFormData?.game_id || "",
          validation: {
            required: true,
          },
          // Game field is never disabled as user needs to be able to change back to football
        },
       
      ],
    },
    
    // Second row - Status
    {
      shape: "div",
      type: "wrapper",
      className: "",
      sx: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gridColumnGap: "100px",
        mt: 6,
      },
      children: [
         {
          shape: "input",
          type: "select",
          name: "league_name",
          className: "border",
          title: "League",
          label: "League",
          options: values.leagues,
          placeholder: "English Premier League",
          width: "100%",
          value: values.currentFormData?.league_name || "",
          isDisabled: values.fieldsDisabled, // Disable based on game selection
          validation: {
            required: true,
          },
        },
        {
          shape: "input",
          type: "select",
          name: "active",
          className: "border",
          title: "Status",
          label: "Status",
          options: [{name:'Active',id:true}, {name:'Inactive',id:false}],
          placeholder: "Status",
          width: "100%",
          value: values.currentFormData?.is_active || "",
          isDisabled: values.fieldsDisabled, // Disable based on game selection
          validation: {
            required: true,
          },
        },
      ],
    },
    
    // Third row - Color fields
    {
      shape: "div",
      type: "wrapper",
      className: "",
      sx: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gridColumnGap: "100px",
        mt: 6,
      },
      children: [
        {
          shape: "input",
          type: "text",
          name: "card_color",
          className: "border",
          title: "Card Color",
          label: "Card Color",
          placeholder: "Enter Card Color",
          width: "100%",
          value: values.currentFormData?.card_color,
          isDisabled: values.fieldsDisabled, // Disable based on game selection
        },
        {
          shape: "input",
          type: "text",
          name: "progress_bar_color",
          className: "border",
          title: "Progress Bar Color",
          label: "Progress Bar Color",
          placeholder: "Enter Progress Bar Color",
          width: "100%",
          value: values.currentFormData?.progress_bar_color,
          isDisabled: values.fieldsDisabled, // Disable based on game selection
        }
      ],
    },
    
    // Fourth row - More color fields
    {
      shape: "div",
      type: "wrapper",
      className: "",
      sx: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gridColumnGap: "100px",
        mt: 6,
      },
      children: [
        {
          shape: "input",
          type: "text",
          name: "btn_text_color",
          className: "border",
          title: "Button Text Color",
          label: "Button Text Color",
          placeholder: "Enter Button Text Color",
          width: "100%",
          value: values.currentFormData?.btn_text_color,
          isDisabled: values.fieldsDisabled, // Disable based on game selection
        },
        {
          shape: "input",
          type: "text",
          name: "btn_background_color",
          className: "border",
          title: "Button Background Color",
          label: "Button Background Color",
          placeholder: "Enter Button Background Color",
          width: "100%",
          value: values.currentFormData?.btn_background_color,
          isDisabled: values.fieldsDisabled, // Disable based on game selection
        }
      ],
    },
   
    // Buttons
    {
      shape: "div",
      type: "wrapper",
      className: "",
      sx: { display: "flex", justifyContents: "flex-start", mt: 6 },
      children: [
        {
          shape: "button",
          type: "action",
          title: values.mode === "view" ? "Edit" : "Add",
          submitButton: true,
          name: "Add",
          sx: {mr:2},
          isDisabled: values.fieldsDisabled, // Disable submit button when fields are disabled
          validation: {
            hiddenRules: [
              {
                mode: "view",
              },
            ],
          },
        },
        {
          shape: "button",
          type: "cancel",
          title: "Cancel",
          variant: "outlined",
          name: "cancel",
          sx: {
            mr: 2,
          },
        },
      ],
    },
  ];
}